import React from 'react';
import { Body, Box, BoxProps, Icon } from '@hover/blueprint';
import { iMessageSquare } from '@hover/icons';
import NewsLetterLink from './NewsLetterLink';

interface Props extends BoxProps {
  iconColor: string;
}

const NewsLetterContactUs: React.FC<Props> = ({ iconColor, ...restProps }) => (
  <Box
    flex={1}
    w={{ base: '100%', desktop: '200px' }}
    flexDir="column"
    alignItems="start"
    {...restProps}
  >
    <Icon m={0} icon={iMessageSquare} color={iconColor} size="large" />
    <Body color="neutral.0" size={500} isBold pt={500} pb={400}>
      ANY OTHER QUESTIONS?
    </Body>
    <Body maxW="90%" color="neutral.0" size={500} pb={500}>
      We’re always just a phone call (or email, or chat) away.
    </Body>
    <NewsLetterLink
      to={`${process.env.GATSBY_V2_PREFIX}/contact`}
      title="Contact us"
    />
  </Box>
);

export default NewsLetterContactUs;
